var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"outlined":_vm.outlined,"small":_vm.small,"min-width":_vm.minWidth,"block":_vm.block,"data-testid":"btnCustomBtn"},on:{"click":_vm.onClick}},[(_vm.icon)?_c('v-icon',{attrs:{"left":""}},[_vm._v(" "+_vm._s(_vm.icon)+" ")]):_vm._e(),_vm._v(" "+_vm._s(_vm.text)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }